import React from "react";
import main from "../../Assets/png/main.png";



const Changepass=()=>{
    return(
        <div style={{display:'flex'}} className="row">

            <div className="col-4">
                <img src={main} alt="" style={{width:'50%'}}/>
            </div>


            <div style={{display:'flex',justifyContent:'center',alignItems:'center'}} className="col-8">
                <div style={{margin:'0'}}>
                    <div style={{marginBottom:'16px'}}>
                        <span style={{fontFamily:'Satoshi',fontSize:'30px',fontWeight:'900',lineHeight:'40.5px',color:'#212129'}}>Reset Your Password</span>
                    </div>
                    <div style={{marginBottom:'24px'}}>
                        <span style={{fontFamily:'Satoshi',fontSize:'14px',fontWeight:'400',lineHeight:'18.9px',color:'#8790A1'}}>Set memorable password for easy log-in</span>
                    </div>
                    <div>
                        <input type="password" placeholder="Enter your password"style={{marginBottom:'16px',borderRadius:'8px',border:'1px solid #0048FF',padding:'12px 16px 12px 16px',fontFamily:'Satoshi',fontSize:'14px',fontWeight:'400',lineHeight:'16.03px',color:'#9EA4B2'}}/>
                    </div>

                    <div style={{marginBottom:'24px'}}>
                        <input type="password" placeholder="Confirm your password"style={{borderRadius:'8px',border:'1px solid #F6F6F6',padding:'12px 16px 12px 16px',fontFamily:'Satoshi',fontSize:'14px',fontWeight:'400',lineHeight:'16.03px',color:'#9EA4B2'}}/>
                    </div>
                    <div style={{borderRadius:'16px',padding:'10px',gap:'10px',backgroundColor:'#6929E2',display:'flex',justifyContent:'center',alignItems:'center'}}>
                        <span style={{fontFamily:'Satoshi',fontSize:'14px',fontWeight:'900',lineHeight:'18.9px',color:'#FFFFFF',margin:'0'}}>Reset Password</span>

                    </div>

                </div>
            </div>


        </div>

    );
};
export default Changepass;